'use strict';

import { KeycloakConfig } from 'keycloak-js';

export class Config {
  static API = '';
  static apiUrl = '';
  static sgeUrl = '';
  static hasRtukUrl = false;
  static onlyOffice = { url: '' };
  static keycloak: KeycloakConfig = { url: '', realm: '', clientId: '' };
}
